var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"filter","transform":"translate(0 -0.038)"},React.createElement("path",{"id":"Shape","d":"M10.4,19.705a.5.5,0,0,1-.5-.5V12.455L2.192,4.741h-.7A1.494,1.494,0,0,1,0,3.249V1.492A1.494,1.494,0,0,1,1.492,0H22.507A1.494,1.494,0,0,1,24,1.492V3.249a1.494,1.494,0,0,1-1.493,1.492h-.68l-7.713,7.714v3.539a.494.494,0,0,1-.146.352L10.754,19.56A.494.494,0,0,1,10.4,19.705ZM3.6,4.741,10.754,11.9a.5.5,0,0,1,.146.354v5.755l2.219-2.219V12.253a.5.5,0,0,1,.146-.356L20.42,4.741ZM1.492,1a.5.5,0,0,0-.5.5V3.249a.5.5,0,0,0,.5.5H22.507a.5.5,0,0,0,.5-.5V1.492a.5.5,0,0,0-.5-.5Z","transform":"translate(0 0.038)","fill":"#DE375C"})));
}

Filter.defaultProps = {"width":"24","height":"19.706","viewBox":"0 0 24 19.706"};

module.exports = Filter;

Filter.default = Filter;
